<div class="container">
  <div
    class="top"
    [ngStyle]="{ 'background-image': 'url(' + tile?.backgroundUrl + ')' }">
    <h4>{{ tile?.headline }}</h4>
  </div>
  <p [innerHTML]="tile?.text"></p>
</div>
